import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

export const useBreakEvenGuard = () => {
  const [pending, setPending] = useState<{
    price: number;
    breakEven: number;
    save: () => void;
  } | null>(null);

  const requestSave = (price: number, breakEven: number | null, save: () => void) => {
    if (price > 0 && breakEven !== null && price < breakEven) {
      setPending({ price, breakEven, save });
      return;
    }
    save();
  };

  const confirmDialog = (
    <Dialog open={pending !== null} onClose={() => setPending(null)} maxWidth="xs" fullWidth>
      <DialogTitle>Price is below break-even</DialogTitle>
      <DialogContent>
        <Typography>
          Entered price: ${pending?.price.toFixed(2)}. Break-even price: $
          {pending?.breakEven.toFixed(2)}. Save this price anyway?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setPending(null)}>Cancel</Button>
        <Button
          variant="contained"
          onClick={() => {
            const save = pending?.save;
            setPending(null);
            save?.();
          }}
        >
          Save anyway
        </Button>
      </DialogActions>
    </Dialog>
  );

  return { requestSave, confirmDialog };
};
